import { useUserInfo } from "@/api/request";
import Icon from "@/wmCompoments/Icon";
import { IconName } from "@/wmCompoments/Icon/iconTypes";
import Input from "@/wmCompoments/input";
import classNames from "classnames";
import React, { useMemo } from "react";
import styles from './topInfo.module.scss'
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

const TopInfo = () => {
    const { t } = useTranslation('personalInfo')

    const { data } = useUserInfo()
    const bases = useMemo(() => {
        const baseActivity = data?.realName && data?.sex && data?.birthday;
        const bindPhoneActivity = !!data?.phone;
        const bindEmailActivity = !!data?.email;
        return [
            {
                icon: 'icon-user-baseinfo',
                text: t('fillBasicInfo'),
                activity: baseActivity
            },
            {
                icon: 'icon-user-mobile',
                text: t('bindPhoneNumber'),
                activity: bindPhoneActivity
            },
            {
                icon: 'icon-user-email',
                text: t('bindEmail'),
                activity: bindEmailActivity
            }
        ]
    }, [data])

    const state = useMemo(() => {
        const activityCount = [
            data?.realName && data?.sex && data?.birthday,
            !!data?.phone,
            !!data?.email
        ].filter(Boolean).length;
    
        if (activityCount === 3) {
            return { type: 'high', text: t('high') };
        } else if (activityCount === 2) {
            return { type: 'middle', text: t('medium') };
        } else if (activityCount === 1) {
            return { type: 'low', text: t('low') };
        } else {
            return { type: 'none', text: t('none') }; // 可选的默认值
        }
    }, [data]);

    return <div>
        <div className={styles.title}>{t('profile')}</div>
        <div className={classNames(styles.warpper)}>

            <div className={classNames(styles.warpperItem)}
                onClick={(e) => {
                    e.stopPropagation()
                    if (ut.copyBoard(data?.name)) {
                        Toast.show(t('copySuccess'))
                    }
                }}
            >
                <span>{t('account')}</span>
                <Input value={data?.name} suffix={
                    <Icon name={'icon-games-copy'} className={styles.iconCopy} />
                } hidePlaceholder={true} readOnly={true} />
            </div>

            <div className={classNames(styles.warpperItem)}
                onClick={(e) => {
                    e.stopPropagation()
                    if (ut.copyBoard(data?.id)) {
                        Toast.show(t('copySuccess'))
                    }
                }}
            >
                <span>{t('userId')}</span>
                <Input value={data?.id?.toString()} suffix={
                    <Icon name={'icon-games-copy'} className={styles.iconCopy} />
                } hidePlaceholder={true} readOnly={true} />
            </div>
        </div>


        <div className={styles.warpperDescribe}>
            <div>
                <span>{t('accountSecurityLevel')}</span>
                <span className={
                    classNames({
                        [styles.high]: state.type === 'high',
                        [styles.middle]: state.type === 'middle',
                        [styles.low]: state.type === 'low'
                    })
                }>{
                    state.text
                }</span>
            </div>
            <div className={styles.describe}>
                <span>{t('securityReminder')}</span>
            </div>
        </div>

        <div className={classNames(styles.warpperColumns)}>
            {
                bases.map((v, index) => {
                    return <div key={index} className={classNames(styles.columnsItem,{
                        [styles.columnsItemActivity]: v.activity
                    })}>
                        <Icon name={v.icon as IconName} className={styles.icon} />
                        <span>{v.text}</span>
                    </div>
                })
            }
        </div>
    </div>
}

export default TopInfo